import { saveChat } from '@api/api';
import { AI_MODEL } from '@api/constant';
import { Platform } from 'react-native';
import type { ChatMessage } from './chatUtils';

export interface SaveChatConfig {
  chatMessages: ChatMessage[];
  globalUser: any;
  userData: any;
  isEditorConnected: boolean;
  hasChatToSave: () => boolean;
}

/**
 * Save chat conversation
 */
export const createSaveChatConversation = (config: SaveChatConfig) => {
  const { chatMessages, globalUser, userData, isEditorConnected, hasChatToSave } = config;

  return async (): Promise<boolean> => {
    try {
      if (!hasChatToSave()) {
        return false;
      }

      const userId = globalUser?._id || globalUser?.id || globalUser?.userId;
      const companyId = userData?.companyId || userData?.company?._id || userData?.company?.id;

      const messages = chatMessages
        .filter(
          (msg) =>
            msg.text &&
            msg.text.trim().length > 0 &&
            !msg.isDisclaimer &&
            !msg.formSchema &&
            !msg.actionCards &&
            !msg.showProfileForm &&
            !msg.showOnboardingForm
        )
        .map((msg) => {
          const role =
            (msg.user && msg.user._id !== globalUser) || msg.system ? 'assistant' : 'user';
          const content = msg.text || msg.content || '';
          return {
            role: role as 'user' | 'assistant' | 'system',
            content: content,
          };
        });

      const sessionDuration =
        chatMessages.length > 1
          ? new Date(chatMessages[0].createdAt).getTime() -
            new Date(chatMessages[chatMessages.length - 1].createdAt).getTime()
          : 0;

      const chatData = {
        userId: userId,
        companyId: companyId,
        messages,
        metadata: {
          editorConnected: isEditorConnected,
          sessionDuration: Math.abs(sessionDuration),
          aiModel: AI_MODEL || 'gpt-3.5-turbo',
          messageCount: chatMessages.length,
          chatInterface: 'easy-mode',
        },
      };

      const result = await saveChat(chatData);

      if (result?.success) {
        if (Platform.OS === 'web' && typeof window !== 'undefined' && window.dispatchEvent) {
          const refreshEvent = new CustomEvent('chatSaved', {
            detail: { chatId: result.data?.chatId, source: 'easy-mode' },
          });
          window.dispatchEvent(refreshEvent);
          console.log('🔄 Dispatched chatSaved event to refresh chat history');
        }
        return true;
      } else {
        console.error('❌ Failed to save chat:', result?.message || 'Unknown error');
        return false;
      }
    } catch (error) {
      console.error('❌ Error saving chat:', error);
      return false;
    }
  };
};




